import { createAction, props } from "@ngrx/store";

import { AchAccountInfo } from "../../definitions/ach-account-info";
import { FailState } from "../models/fail-state";

export class VendorAchActions {
	static readonly TYPES = {
		nameChangeRequested: "[Vendor ACH] Name Change Requested",
		namedChanged: "[Vendor ACH] Name Changed",
		nameChangeFailed: "[Vendor ACH] Name Change Failed"
	};
	static readonly nameChangeRequested = createAction(
		VendorAchActions.TYPES.nameChangeRequested,
		props<{ accountId: string; accountName: string; isActive: boolean }>()
	);
	static readonly namedChanged = createAction(VendorAchActions.TYPES.namedChanged);
	static readonly nameChangeFailed = createAction(
		VendorAchActions.TYPES.nameChangeFailed,
		props<FailState>()
	);
	static readonly createAccount = {
		create: createAction(
			"[vendor/achAccount] create",
			props<{ achAccountInfo: AchAccountInfo }>()
		),
		createSuccess: createAction(
			"[vendor/achAccount] create success",
			props<{ achCommerceId: string }>()
		),
		createFail: createAction("[vendor/achAccount] create fail", props<FailState>())
	};
}
